const initPlayer = (playerId, videoId) => {
  return new YT.Player(playerId, {
    videoId,
    playerVars: {
      rel: 0,
    },
    // events: {
    //   'onReady': () => {
    //     console.warn('player is ready');
    //   },
    // }
  });
};

export default initPlayer;
